import jsonApi from '../../utils/jsonApi'
import http from '../../utils/http'

const schoolContentCreators = 'school_content_creator'
const schoolAdministrator = 'school_administrator'
const schoolCoordinator = 'school_coordinator'
const schoolTeacher = 'school_teachers'
const schoolNurse = 'school_nurse'
const schoolPsychologist = 'school_psychologist'
const schoolOmbudsman = 'school_ombudsman'
const schoolFinance = 'school_finance'
const schoolSecretary = 'school_secretary'

export const getSchoolConfig = schoolId => {
  return jsonApi
    .find('school_config', '', {
      params: {
        'q[school_id_eq]': schoolId
      }
    })
    .then(res => res.data?.[0])
}

export const updateSchoolConfig = params => {
  return http
    .put(`school_configs/${params.id}`, {
      data: {
        id: params.id,
        type: 'school_configs',
        attributes: {
          ...params.data
        }
      }
    })
    .then(res => res.data)
}

export const fetchContentCreatorById = id =>
  jsonApi
    .find(schoolContentCreators, '', {
      params: {
        'q[user_id_in]': id,
        include: 'school'
      }
    })
    .then(res => res.data)

export const fetchAdministratorById = async id => {
  let currentPage = 1
  const response = await jsonApi
    .find(schoolAdministrator, '', {
      params: {
        'q[user_id_in]': id,
        'page[number]': currentPage,
        include: 'school'
      }
    })
    .then(res => res)
  let fullResponse = { ...response }
  while (fullResponse.data.length < fullResponse.meta.total_count) {
    currentPage += 1
    let responseForNextPage = await jsonApi
      .find(schoolAdministrator, '', {
        params: {
          'q[user_id_in]': id,
          'page[number]': currentPage,
          include: 'school'
        }
      })
      .then(response => response.data)
    fullResponse.data = [...fullResponse.data, ...responseForNextPage]
  }
  return fullResponse.data
}

export const fetchCoordinatorById = id => {
  return jsonApi
    .find(schoolCoordinator, '', {
      params: {
        'q[user_id_in]': id,
        include: 'school'
      }
    })
    .then(res => res.data)
}

export const fetchSchoolPsychologistByUserId = id => {
  return jsonApi
    .find(schoolPsychologist, '', {
      params: {
        'q[user_id_eq]': id,
        include: 'school'
      }
    })
    .then(res => res.data)
}

export const fetchSchoolOmbudsmanByUserId = id => {
  return jsonApi
    .find(schoolOmbudsman, '', {
      params: {
        'q[user_id_eq]': id,
        include: 'school'
      }
    })
    .then(res => res.data)
}

export const fetchSchoolFinanceByUserId = id => {
  return jsonApi
    .find(schoolFinance, '', {
      params: {
        'q[user_id_eq]': id,
        include: 'school'
      }
    })
    .then(res => res.data)
}

export const fetchSchoolSecretaryByUserId = id => {
  return jsonApi
    .find(schoolSecretary, '', {
      params: {
        'q[user_id_eq]': id,
        include: 'school'
      }
    })
    .then(res => res.data)
}

export const fetchSchoolNurseByUserId = id => {
  return jsonApi
    .find(schoolNurse, '', {
      params: {
        'q[user_id_eq]': id,
        include: 'school'
      }
    })
    .then(res => res.data)
}

export const fetchSchoolTeachers = params => {
  return http.get(schoolTeacher, {
    params: {
      ...params
    }
  })
}

export const fetchTeacherById = ({ id, params }) =>
  jsonApi
    .findAll(schoolTeacher, {
      params: {
        'q[user_id_in]': id,
        include: 'school',
        ...params
      }
    })
    .then(res => res.data)

export const updateLayoutSchool = data =>
  http
    .put(`schools/${data.id}`, data.data, {
      'Content-Type': 'multipart/form-data'
    })
    .then(res => res.data)

export const fetchSchools = id =>
  jsonApi
    .findAll('school', {
      params: {
        'q[id_eq]': id,
        'page[size]': 20
      }
    })
    .then(res => res.data)
